module.exports = new __parcel__URL__("Planet_B_teaser_zh-tw.2a5cabba.webp").toString();